import { Form } from "antd";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { CardTypeEntity } from "src/app/features/CardType/types/CardTypeEntity";
import { SelectDynamic, TextInput } from "../../../../../components/Form/formComponents";
import { NumberInput } from "../../../../../components/Form/formComponents/Number/NumberInput";
import type { SearchFormProps } from "../../../../../components/Form/types/types";
import { cardTypeSelectConfig, statusSelectorConfig } from "../../../../../components/SearchForm/FormSearchUtils";
import { SearchForm } from "../../../../../components/SearchForm/SearchForm";

export const CardTypesSearchForm: FC<SearchFormProps<CardTypeEntity>> = ({ searchCallback }) => {
    const { t } = useTranslation();
    return (
        <SearchForm searchCallback={searchCallback}>
            <Form.Item label={t("form.system.id")} name="id">
                <NumberInput name="id" readOnly={false} />
            </Form.Item>
            <Form.Item label={t("applicationProfileCreateForm.cardType")} name="cardType">
                <SelectDynamic name="cardType" label={t("form.status")} fieldConfig={cardTypeSelectConfig} />
            </Form.Item>
            <Form.Item label={t("form.name")} name="name">
                <TextInput name="name" />
            </Form.Item>
            <Form.Item label={t("form.status")} name="status">
                <SelectDynamic name="status" label={t("form.status")} fieldConfig={statusSelectorConfig} />
            </Form.Item>
        </SearchForm>
    );
};
